import { render, staticRenderFns } from "./Barangays.vue?vue&type=template&id=b9c1bdf2&"
import script from "./Barangays.vue?vue&type=script&lang=js&"
export * from "./Barangays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports